<dx-data-grid
id="tasks-grid"
class="theme-dependent"
height="100%"
[dataSource]="dataSource"
[hoverStateEnabled]="true"
[columnAutoWidth]="true"
[showBorders]="true"
(onRowClick)="onRowClick($event)"
>

  <dxo-paging [pageSize]="pageSize"></dxo-paging>
  <dxo-pager [visible]="true" [showPageSizeSelector]="true"></dxo-pager>
  <dxo-editing mode="row" [allowUpdating]="false"></dxo-editing>
  <dxo-selection
    selectAllMode="allPages"
    showCheckBoxesMode="always"
    mode="multiple"
  ></dxo-selection>
  <dxo-scrolling mode="virtual"></dxo-scrolling>
  <dxo-sorting mode="multiple"></dxo-sorting>
  <dxo-header-filter [visible]="true"></dxo-header-filter>

  <dxi-column
    *ngFor="let column of columns"
    [dataField]="column.dataField"
    [caption]="column.caption"
    [dataType]="column.dataType"
    [hidingPriority]="column.hidingPriority"
    [minWidth]="column.minWidth"
  >
    <dxi-validation-rule *ngFor="let rule of column.validationRules" [type]="rule.type"></dxi-validation-rule>
    <dxo-lookup *ngIf="column.lookup" [dataSource]="column.lookup.dataSource"></dxo-lookup>
  </dxi-column>
  

   @if (Id == ActionIDs.Stock) {
   
  
   }
   @else if (Id == ActionIDs.MerchantOrders) {
    <dxi-column [width]="300" [cellTemplate]="'actionsTemplate'"></dxi-column>
    <div *dxTemplate="let cellInfo of 'actionsTemplate'">
      
      @if (cellInfo.key.status == "Pending") {
        <dx-button
        hint="Delete"
        class="action-button"
        (onClick)="deleteRow(cellInfo)">Generate Dispatch Notice</dx-button>
      }
      @else if (cellInfo.key.status == "New")  {
        <dx-button
        hint="Delete"
        class="action-button"
        (onClick)="deleteRow(cellInfo)">Allocate Cards</dx-button>
      }
      @else if (cellInfo.key.status == "Preparing")  {
        <dx-button
        hint="Delete"
        class="action-button"
        (onClick)="deleteRow(cellInfo)">Dispatch</dx-button>

        <dx-button
        hint="Delete"
        class="action-button"
        (onClick)="deleteRow(cellInfo)">Download Dispatch Notice</dx-button>
      }
    </div>
   }
   @else if (Id == ActionIDs.ActiveOrders) {

   }
   @else if (Id == ActionIDs.Deactivated) {}
   


</dx-data-grid>
  <!-- <div *ngFor="let column of columns" *dxTemplate="let cellInfo of column.cellTemplate">
    <status-indicator
      [isField]="false"
      [showBar]="column.showBar"
      [value]="cellInfo.data[column.dataField]"
    ></status-indicator>
  </div>

  <div *ngFor="let column of columns" *dxTemplate="let cellInfo of column.editCellTemplate">
    <dx-select-box
      class="edit-cell"
      [(value)]="cellInfo.value"
      [items]="column.lookup?.dataSource"
      (onValueChanged)="cellInfo.setValue($event.value)"
      (onSelectionChanged)="cellInfo.component.updateDimensions()"
      fieldTemplate="field"
    >
      <div *dxTemplate="let data of 'field'">
        <status-indicator
          [showBar]="true"
          [value]="cellInfo.value"
        ></status-indicator>
      </div>
      <div *dxTemplate="let data of 'item'">
        <status-indicator
          [showBar]="true"
          [isField]="false"
          [value]="data"
        ></status-indicator>
      </div>
    </dx-select-box>
  </div> -->
